import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYoutubeLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 26,
	height: 18,
	viewBox: "0 0 26 18",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .280273,
		width: 25.4386,
		height: 18.001,
		rx: 8,
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20.4356 0H5.56355C2.64567 0 0.280273 2.3654 0.280273 5.28327V12.7177C0.280273 15.6356 2.64567 18.001 5.56355 18.001H20.4356C23.3535 18.001 25.7189 15.6356 25.7189 12.7177V5.28327C25.7189 2.3654 23.3535 0 20.4356 0ZM16.8626 9.36222L9.90642 12.6799C9.72107 12.7683 9.50697 12.6331 9.50697 12.4278V5.58512C9.50697 5.37686 9.7267 5.24189 9.91244 5.33603L16.8686 8.86106C17.0754 8.96585 17.0718 9.26245 16.8626 9.36222Z",
		fill: "#F61C0D"
	})]
});
export default SvgYoutubeLogo;
